module.exports = __webpack_public_path__ + "img/e41.9a78b065.png";